module.exports = __webpack_public_path__ + "static/media/review-bg-mob@2x.de7d771c.jpg";